import './expo_page.css';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate

import Anapp from './shnapr.png';
import shpp from './shapp.jpg';
import plugin from './geoutilities.jpg';
import cfr from './cfr.jpg';
import gdbves from './gbd_vantage.png';
import { useTranslation } from 'react-i18next';

function Ves() {
    const { t, i18n } = useTranslation();

    const images = [
        Anapp, // Replace with your image URLs
        shpp,
        plugin,
        cfr
    ];

    const descriptions = t('pages.vests.imgdescr2', { returnObjects: true });

    const [currentIndex, setCurrentIndex] = useState(0); // State to track the current image index

    // Function to go to the previous image
    const prevImage = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === 0 ? images.length - 1 : prevIndex - 1
        );
    };

    // Function to go to the next image
    const nextImage = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === images.length - 1 ? 0 : prevIndex + 1
        );
    };

    const navigate = useNavigate();

    const handleButtonblog = () => {
    window.open('https://community.sofhare.com/t/il-valore-dei-dati-geospaziali-archiviazione-e-analisi-predittiva/24', '_blank');
    };

    return(

        <div className="main-wrapper">
            <div className="tools-wrapperS2">
                    <h1> {t('pages.vests.t5')}</h1>
                    <h1> {t('pages.vests.t6')} </h1>
                <div className="sez2" >
                    <div className="text-im">
                        {/* Eventuale descrizione finale */}
                        <p>{t('pages.vests.dsc10')}</p>
                        <p>{t('pages.vests.dsc11')}</p>
                        <p>{t('pages.vests.dsc12')}</p>
                        <p>{t('pages.vests.dsc13')}</p>
                        <p >{t('pages.vests.t7')}</p>
                            <ul className="text-im-list">
                            {/* Lista di paragrafi, evita i <br/> */}
                            {[t('pages.vests.t9'),t('pages.vests.t10'),t('pages.vests.t11'),
                            t('pages.vests.t12')].map((i) => (
                              <li key={i} className="text-im-paragraph">
                                {t(`${i}`)}
                              </li>
                            ))}
                            </ul>
                        <p >{t('pages.vests.t13')}</p>
                            <ul className="text-im-list">
                            {/* Lista di paragrafi, evita i <br/> */}
                            {[t('pages.vests.t14'),t('pages.vests.t15')].map((i) => (
                              <li key={i} className="text-im-paragraph">
                                {t(`${i}`)}
                              </li>
                            ))}
                            </ul>
                     {/* Terzo blocco: Navigazione Bottone */}
                      <div className="pricing-button" onClick={() => navigate('/newuser')} style={{ cursor: 'pointer' }}>
                        <div className="ic1-block">
                                <h3 className="preview-title">{t('pages.vests.t18')}</h3>
                            </div>
                      </div>
                  </div>
                </div>
            </div>

            <div className="tools-wrapperS1">
              <div className="sez1">
                <div className="bloc-cont">
                  {/* Primo blocco: Carousel + descrizione */}
                  <div className="ic2">
                    <div className="image-and-description">
                      <img
                        src={images[currentIndex]} // immagine corrente
                        alt={`Image ${currentIndex + 1}`}
                        className="carousel-image"
                      />
                      <p className="image-description">
                        {descriptions[currentIndex]}
                      </p>
                      {/* Puntini di navigazione */}
                      <div className="dots">
                        {images.map((_, idx) => (
                          <span
                            key={idx}
                            className={`dot ${idx === currentIndex ? 'active' : ''}`}
                            onClick={() => setCurrentIndex(idx)}
                          ></span>
                        ))}
                      </div>
                    </div>
                  </div>
                  {/* Secondo blocco: Blog Preview */}
                  <div className="ic2" onClick={() => window.open('https://community.sofhare.com/', '_blank')} style={{ cursor: 'pointer' }}>
                    <img src={gdbves} alt="Blog Preview" className="carousel-image-small" />
                  </div>
                </div>
              </div>
            </div>
        </div>

    );
}


export default Ves;
